/* @deprecated Copied to app/modules/procurement/pages/vendors_management/vendor-profile/businessDetails/edit-bank-details.tsx. This file still serves the existing /UProcure routes. */
/* eslint-disable jsx-a11y/anchor-is-valid */
/**
 * @file edit-bank-details.tsx
 * @module app/modules/uProcure/vendors_management/vendor-profile/businessDetails/edit-bank-details
 * @description Page component for managing edit bank details in the vendors management section.
 *   Displays a list of edit bank details with pagination, search functionality, and CRUD operations.
 *   Allows users to view the details of edit bank details with warehouse context integration.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 2.1.2
 */

import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { CustomSelectWhite } from "../../../../../custom/Select/CustomSelectWhite";
import { BANKTYPES } from "../../../../../../utils/staticJSON";

const EditBankDetails = (props: any) => {
  const business = props?.editData?.business || {};
  return (
    <div className="card-body bg-light pt-9 pb-0">
      <Row>
        {/* ================= BANK DETAILS ================= */}
        {business.banks &&
          business.banks.map((bank: any, idx: number) => (
            <Row key={idx} className={`mb-3 ${idx !== business.banks.length - 1 ? 'border-bottom pb-3' : ''}`}>
              <Col md={6} className="mb-3">
                <Form.Label className="fs-16 fw-500">
                  Bank Name
                </Form.Label>
                <Form.Control
                  value={bank.bankName}
                  onChange={(e: any) =>
                    props.hanldeBankDetails(
                      e.target.value,
                      "bankName",
                      idx
                    )
                  }
                  className="form-control-custom bg-white"
                  placeholder="Type here…"
                />
              </Col>
              <Col md={6} className="mb-3">
                <Form.Label className="fs-16 fw-500">Branch</Form.Label>
                <Form.Control
                  value={bank.branchName}
                  onChange={(e: any) =>
                    props.hanldeBankDetails(
                      e.target.value,
                      "branchName",
                      idx
                    )
                  }
                  className="form-control-custom bg-white"
                  placeholder="Type here…"
                />
              </Col>

              <Col md={6} className="mb-3">
                <Form.Label className="fs-16 fw-500">
                  Account Number
                </Form.Label>
                <Form.Control
                  value={bank.accountNumber}
                  onChange={(e: any) =>
                    props.hanldeBankDetails(
                      e.target.value,
                      "accountNumber",
                      idx
                    )
                  }
                  className="form-control-custom bg-white"
                  placeholder="Type here…"
                />
              </Col>
              <Col md={6} className="mb-3">
                <Form.Label className="fs-16 fw-500">
                  Identifier Code
                </Form.Label>
                <Form.Control
                  value={bank.identifierCode}
                  onChange={(e: any) =>
                    props.hanldeBankDetails(
                      e.target.value,
                      "identifierCode",
                      idx
                    )
                  }
                  className="form-control-custom bg-white"
                  placeholder="Type here…"
                />
              </Col>
              <Col md={6} className="mb-3">
                <Form.Label className="fs-16 fw-500">
                  Select Bank
                </Form.Label>
                <CustomSelectWhite
                  onChange={(val: any) =>
                    props.hanldeBankDetails(val?.value, "bankType", idx)
                  }
                  options={BANKTYPES}
                  isMulti={false}
                  value={BANKTYPES.find(item => item.value == bank?.bankType)}
                />
              </Col>
              {bank?.bankType ? (
                <Col md={6} className="mb-3">
                  <Form.Label className="fs-16 fw-500">
                    {`${BANKTYPES.find(
                      (item) => item.value == bank?.bankType
                    )?.title || ""
                      } Number`}
                  </Form.Label>
                  <Form.Control
                    value={bank.tigoNumber}
                    onChange={(e: any) =>
                      props.hanldeBankDetails(
                        e?.target?.value,
                        "tigoNumber",
                        idx
                      )
                    }
                    className="form-control-custom bg-white"
                    placeholder="Type here…"
                  />
                </Col>
              ) : (
                <></>
              )}

              <Col xs={12} className="d-flex align-items-end mb-3">
                {idx > 0 && (
                  <Button className="uw-btn uw-btn-danger"
                    variant="danger"
                    onClick={() => props.hanldeRemove(idx)}
                  >
                    Remove
                  </Button>
                )}
              </Col>
            </Row>
          ))}
        <div className="d-flex pb-9">
          <Button className="uw-btn uw-btn-primary" variant="primary" onClick={props.hanldeAddMore}>
            Add bank account
          </Button>
        </div>
      </Row>
    </div>
  );
};

export { EditBankDetails };

